<template>
  <div :class="{'calendar_header_day': true}">
    <div :class="{'calendar_header_day_text': true, 'weekend': isWeekend}">{{ day }}</div>
  </div>
</template>

<script>
export default {
  props: {
    day: {
      type: String,
      default: function() {
        return '';
      },
    },
    isWeekend: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
  },
};
</script>
